module.exports = "/365FarmNet/dist/livestock.c6ec24a61c06dd10eb830deeb8c0870e.html";